import { z } from "zod";
import { BaseOutputSchema } from "../BaseOutput";
import { ReportExecutionHistoryDownloadDtoSchema } from "./ReportExecutionHistoryDownloadDto";

export const GetExecutedReportDataOutputSchema = BaseOutputSchema.extend({
    reportIsGenerated: z.boolean().default(false),
    reportFilePath: z.string().nullable(),
    reportFileName: z.string().nullable(),
    reportExecutionHistory: ReportExecutionHistoryDownloadDtoSchema.nullable(),
    count: z.number(),
});

export type GetExecutedReportDataOutput = z.infer<typeof GetExecutedReportDataOutputSchema>;